// Lazy loaders: each tool is a separate chunk.
import type { ToolId } from '../registry';
import type { ToolFactory } from './types';

const loaders: Record<ToolId, () => Promise<{ default: ToolFactory }>> = {
  merge: () => import('./merge'),
  split: () => import('./split'),
  extract: () => import('./extract'),
  delete: () => import('./delete'),
  organize: () => import('./organize'),
  rotate: () => import('./rotate'),
  compress: () => import('./compress'),
  repair: () => import('./repair'),
  ocr: () => import('./ocr'),
  imagesToPdf: () => import('./imagesToPdf'),
  wordToPdf: () => import('./office'),
  excelToPdf: () => import('./office'),
  pptToPdf: () => import('./office'),
  pdfToImages: () => import('./pdfToImages'),
  pdfToText: () => import('./pdfToText'),
  pdfToWord: () => import('./pdfToWord'),
  pdfa: () => import('./pdfa'),
  sign: () => import('./sign'),
  pageNumbers: () => import('./pageNumbers'),
  watermark: () => import('./watermark'),
  flatten: () => import('./flatten'),
  metadata: () => import('./metadata'),
  protect: () => import('./protect'),
  unlock: () => import('./unlock'),
  redact: () => import('./redact'),
};

export async function loadTool(id: ToolId): Promise<ToolFactory> {
  return (await loaders[id]()).default;
}
